import { render, staticRenderFns } from "./SurveyEdit.vue?vue&type=template&id=056f7dda&"
import script from "./SurveyEdit.vue?vue&type=script&lang=ts&"
export * from "./SurveyEdit.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports